export default {
  labels: {
    selectOne: 'Seleziona un’opzione',
    selectAll: 'Seleziona tutte le opzioni applicabili',
    typeResponse: 'Digita la tua risposta nella casella di testo sottostante.',
    recordResponse: 'Effettua una registrazione per rispondere alla domanda.',
    enterNumeric: 'Inserisci una risposta numerica nel campo sottostante.',
    rateResponseScale: 'Valuta la tua risposta sulla scala fornita.',
    sliderMinimum: 'Valore minimo: {value}',
    sliderMaximum: 'Valore massimo: {value}',
    selectOneOptionRow: 'Seleziona un’opzione in ogni riga.',
    selectAllOptionsRow: 'Seleziona tutte le opzioni applicabili per ogni riga.',
    dragAndDropResponse: 'Trascina e rilascia le opzioni per ordinarle in base alla preferenza.',
    rankOrderDesktopInstruction: 'Trascina e rilascia gli elementi per classificarli, oppure usa il pulsante + per aggiungere un elemento. Usa i pulsanti freccia per riordinare o il pulsante elimina per rimuovere un elemento.',
    alert: "Avviso",
    error: 'Per favore, inserisci un numero tra {min} e {max}.',
    cameras: 'Fotocamere',
    microphones: 'Microfoni',
    recording: 'Registrazione',
    noDevicesFound: 'Nessun dispositivo trovato',
    camera: 'Fotocamera',
    microphone: 'Microfono',
    stopRecording: 'Interrompi registrazione',
    startRecording: 'Avvia registrazione',
    disableCamera: 'Disattiva fotocamera',
    enableCamera: 'Attiva fotocamera',
    disableMicrophone: 'Disattiva microfono',
    enableMicrophone: 'Attiva microfono',
    settings: 'Impostazioni',
    recordingProgress: 'Progresso della registrazione',
    playbackProgress: 'Progresso della riproduzione',
    play: 'Riproduci',
    pause: 'Pausa',
    stop: 'Interrompi',
    record: 'Registra',
    recordAgain: 'Registra di nuovo',
    retry: 'Riprova',
    done: 'Fatto',
    minRecordTime: 'Per favore, registra una risposta per {min} secondi.',
    enlargeImage: 'Ingrandisci immagine',
    enlargedImage: 'Immagine ingrandita',
    close: 'Chiudi',
    zoomIn: 'Ingrandisci',
    zoomOut: 'Riduci',
    resetZoom: 'Reimposta zoom',
    zoomLevel: 'Zoom {percentage}%',
    imagePosition: '{current} di {total}',
    previousImage: 'Immagine precedente',
    nextImage: 'Immagine successiva',
    imageLoading: 'Caricamento immagine',
    imageLoadFailed: 'Impossibile caricare l\'immagine',
  },
  noSelection: "Nessuna selezione",
  actions: {
    increase: 'Aumenta',
    decrease: 'Riduci'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Anteprima Sondaggio Terminata',
      titleCompleted: 'Anteprima Sondaggio Completata',
      previewModeWarning: 'Questa pagina è visibile solo in Modalità Anteprima e non verrà mostrata ai rispondenti reali.',
      reachedEndPoint: 'Questo sondaggio ha raggiunto un punto finale.',
      reachedEndPointCompleted: 'Questa anteprima ha raggiunto un punto finale.',
      returnToModify: 'Torna alla domanda precedente per modificare le tue risposte e testare un percorso di sondaggio diverso.',
      logic: 'Logica'
    }  }
}
